/**
 * Generische Validierungs-Typen für Controls
 * Diese Typen sind modellunabhängig und können in einer Library verwendet werden.
 */

/** Schweregrad einer Validierung oder eines Kommentars */
export enum ValidationLevel {
	ok = 0,
	warning = 1,
	danger = 2
}

/** Ein einzelner Kommentar eines Prüfers */
export interface CheckerComment {
	name: string;
	msg: string;
	time: number;
}

/** Kommentare zu einem Feld */
export interface CheckerComments {
	resolved: boolean;
	type: ValidationLevel;
	comments: CheckerComment[];
}

/** Validierungsstatus eines Dokuments */
export interface ValidationState {
	resolved?: boolean;
	dataSeverity: ValidationLevel;
	commentsSeverity: ValidationLevel;
	hasDiskussions: boolean;
}

/** Ergebnis einer Validierung */
export class ValidationResult {
	type: ValidationLevel;
	msg?: string;

	constructor(t?: ValidationLevel, m?: string) {
		this.type = t ?? ValidationLevel.ok;
		this.msg = m;
	}

	static ok(): ValidationResult {
		return new ValidationResult();
	}

	static warning(msg: string): ValidationResult {
		return new ValidationResult(ValidationLevel.warning, msg);
	}

	static danger(msg: string): ValidationResult {
		return new ValidationResult(ValidationLevel.danger, msg);
	}

	static message(msg: string): ValidationResult {
		return new ValidationResult(ValidationLevel.ok, msg);
	}
}

/** Typ für Validierungs-Funktionen */
export type ValidatorFunction = (data: unknown, context?: unknown) => ValidationResult;

/** Typ für Evaluierungs-Funktionen */
export type EvaluatorFunction = (context: unknown, index?: number, key?: string, override?: number, flag?: boolean) => string | number | undefined;

/** Option-Definition für ein Feld */
export interface FieldOption {
	tableName?: string;
	tableColumn?: string;
	displayColumn?: string;
	from?: 'hardCoded' | 'dietmarsMdb';
	options?: string;
	nonEmpty?: boolean;
	unit?: string;
	masked?: boolean;
	regex?: string;
	regexFailMessage?: (str: string, regex: string) => string;
	min?: number;
	max?: number;
	placement?: string;
	expandOnClick?: boolean;
	expandOnFocus?: boolean;
	maxItems?: number;
	acceptOtherValues?: boolean;
	prefix?: string;
	integer?: boolean;
}
